import { inject, Injectable } from '@angular/core';
import { ApolloService } from './apollo.service';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ContactService {
  private readonly apolloService = inject(ApolloService);

  unsubscribe(contactId: string): Observable<boolean> {
    return this.apolloService
      .mutate<number>(
        `UnsubscribeContact($contactId: UUID!) {
                    unsubscribeContact(id: $contactId)
                }`,
        'unsubscribeContact',
        { contactId }
      )
      .pipe(map((x) => x > 0));
  }
}
